module.exports = __webpack_public_path__ + "img/stock0.7699f6df.png";